import React, { useEffect, useState } from 'react'
import { Card, Carousel, Col, Container, Row } from 'react-bootstrap'
import '../pages/OurDiffer.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'

const MOBILE_QUERY = '(max-width: 767.98px)'

function useCardsPerSlide() {
    const [isMobile, setIsMobile] = useState(
        () => typeof window !== 'undefined' && window.matchMedia(MOBILE_QUERY).matches
    )

    useEffect(() => {
        const mediaQuery = window.matchMedia(MOBILE_QUERY)
        const handleChange = (event) => setIsMobile(event.matches)

        mediaQuery.addEventListener('change', handleChange)
        return () => mediaQuery.removeEventListener('change', handleChange)
    }, [])

    return isMobile ? 1 : 2
}

const DIFFERENTIATORS = [
    {
        title: 'Unparelled Expertise',
        description: 'Our organization boasts a team of accomplished legal professionals who are recognized as renowned leaders in the field of Alternative Dispute Resolution (ADR) and Online Dispute Resolution (ODR), with years of experience and a proven track record.',
    },
    {
        title: 'Tailored Strategies',
        description: 'Recognizing that no two disputes are alike, we create bespoke resolution strategies that are tailored to your unique circumstances. Our personalized approach means that your case receives the individual attention it deserves, resulting in solutions that align with your goals.',
    },
    {
        title: 'Innovative Approach',
        description: 'We are at the forefront of innovative dispute resolution techniques, seamlessly blending traditional legal practices with cutting-edge technology. Our forward-looking approach ensures that you benefit from the latest advancements in ADR and ODR, setting the stage for efficient and effective resolutions.',
    },
    {
        title: 'Efficiency & Cost-Effectiveness',
        description: 'Litigation can be time-consuming and financially burdensome. By choosing Resolution Experts Alliance, you opt for a streamlined process that saves you both time and money. Our ADR and ODR methods prioritize swift resolutions, allowing you to move forward without the protracted delays and expenses often associated with traditional courtroom battles.',
    },
    {
        title: 'Preservations of Relationships',
        description: 'Our emphasis on collaborative resolution means that we prioritize relationships, even in the midst of disputes. We understand that maintaining working relationships can be crucial, especially in a business context, and our methods reflect this understanding.',
    },
    {
        title: 'Confidentiality and Privacy',
        description: 'At Resolution Experts Alliance, your privacy and confidentiality are of paramount importance. Our stringent standards ensure that sensitive information remains protected throughout the resolution process, fostering an environment of trust and security.',
    },
    {
        title: 'Tech-Forward Solutions',
        description: 'Our integration of state-of-the-art technology in the form of online platforms for ODR underscores our commitment to modern solutions. By harnessing the power of technology, we bring convenience, accessibility, and efficiency to the resolution process.',
    },
    {
        title: 'Educational Empowerment',
        description: 'Beyond resolution, we empower our clients through education. Our training programs and workshops equip you with valuable conflict resolution skills that can be applied to various aspects of your personal and professional life.',
    },
    {
        title: 'Holistic Approach',
        description: 'We recognize that disputes often encompass emotional, practical, and legal dimensions. Our holistic approach takes all these facets into account, leading to well-rounded solutions that address the full spectrum of considerations.',
    },
    {
        title: 'Proven Success',
        description: 'Our history of successfully resolving disputes across a wide range of industries speaks to our effectiveness and dedication. When you choose Resolution Experts Alliance, you are aligning yourself with a legacy of positive outcomes and satisfied clients.',
    },
]

const chunk = (items, size) =>
    Array.from({ length: Math.ceil(items.length / size) }, (_, i) => items.slice(i * size, i * size + size))

function OurDiffer() {
    const cardsPerSlide = useCardsPerSlide()
    const slides = chunk(DIFFERENTIATORS, cardsPerSlide)

    return (
        <Container fluid className='OurDifferContainer'>
            <Row className='justify-content-center'>
                <Col md={10} className='text-center'>
                    <h2 className='differHeading'>Our Differentiators</h2>
                    <p className='differSubheading'>The REAA platform provides a 360&deg; approach to dispute resolution.</p>
                </Col>
            </Row>

            <div className='differCarouselWrap'>
                <Carousel
                    indicators={false}
                    interval={null}
                    prevIcon={<span className='differArrow'><FontAwesomeIcon icon={faChevronLeft} /></span>}
                    nextIcon={<span className='differArrow'><FontAwesomeIcon icon={faChevronRight} /></span>}
                >
                    {slides.map((pair, index) => (
                        <Carousel.Item key={index}>
                            <Row className='justify-content-center g-0 g-md-5'>
                                {pair.map(({ title, description }) => (
                                    <Col md={5} key={title}>
                                        <Card className='differCard'>
                                            <Card.Body className='text-center'>
                                                <h5 className='differCardTitle'>{title}</h5>
                                                <p className='differCardText'>{description}</p>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </Carousel.Item>
                    ))}
                </Carousel>
            </div>
        </Container>
    )
}

export default OurDiffer
